import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import './Privacy.css';

export default function Privacy() {
  const { t, language } = useLanguage();

  return (
    <div className="privacy-page">
      <div className="container">
        <div className="privacy-content">
          {/* Header */}
          <div className="privacy-header">
            <h1 className="privacy-title">
              {language === 'ru' ? 'Политика конфиденциальности' : 'Privacy Policy'} /{' '}
              {language === 'ru' ? 'Privacy Policy' : 'Политика конфиденциальности'}
            </h1>
            <p className="privacy-last-updated">
              {language === 'ru' ? 'Дата последнего обновления' : 'Last Updated'}: 17 октября 2025 г. / October 17, 2025
            </p>
          </div>

          {/* Section 1 */}
          <section className="privacy-section">
            <h2 className="privacy-section-title">
              1. {language === 'ru' ? 'Общие положения' : 'General Provisions'} /{' '}
              {language === 'ru' ? 'General Provisions' : 'Общие положения'}
            </h2>
            <div className="privacy-bilingual">
              <div className="privacy-text-block">
                <p>
                  Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок обработки и защиты персональных данных пользователей (далее — «Пользователи») мобильного приложения и Telegram-бота «Площадка» (далее — «Приложение»).
                </p>
                <p>
                  Приложение принадлежит Обществу с ограниченной ответственностью «ГАЛС»
                </p>
                <p className="privacy-operator">
                  (ООО «ГАЛС», ИНН 1657087881, КПП 1165701001, Россия, 420140, г. Казань, ул. Лаврентьева, д. 11, пом. 1045-1) — далее «Оператор».
                </p>
                <p>
                  Используя Приложение, Пользователь выражает согласие с условиями данной Политики.
                </p>
              </div>
              <div className="privacy-text-block">
                <p>
                  This Privacy Policy ("Policy") describes how the personal data of users ("Users") of the mobile application and Telegram bot "Ploshadka" ("the App") are collected, processed, and protected.
                </p>
                <p>
                  The App is owned and operated by LLC "GALS"
                </p>
                <p className="privacy-operator">
                  (TIN 1657087881, KPP 1165701001, Russia, 420140, Kazan, Lavrentyeva St. 11, office 1045-1) — hereinafter referred to as "the Operator."
                </p>
                <p>
                  By using the App, the User agrees to this Policy.
                </p>
              </div>
            </div>
          </section>

          {/* Section 2 */}
          <section className="privacy-section">
            <h2 className="privacy-section-title">
              2. {language === 'ru' ? 'Обрабатываемые данные' : 'Types of Data Collected'} /{' '}
              {language === 'ru' ? 'Types of Data Collected' : 'Обрабатываемые данные'}
            </h2>
            <div className="privacy-bilingual">
              <div className="privacy-text-block">
                <p>Оператор может собирать и обрабатывать следующие категории данных Пользователей:</p>
                <ul>
                  <li>Имя, никнейм в Telegram, фото профиля, идентификатор пользователя (ID);</li>
                  <li>Контактные данные (номер телефона, e-mail — если предоставлены);</li>
                  <li>Геолокация (город, местоположение площадок);</li>
                  <li>Данные о спортивных интересах, созданных и посещённых событиях;</li>
                  <li>Технические данные: IP-адрес, тип устройства, версия ОС, язык интерфейса, время входа.</li>
                </ul>
              </div>
              <div className="privacy-text-block">
                <p>The Operator may collect and process the following categories of data:</p>
                <ul>
                  <li>Name, Telegram nickname, profile photo, user ID;</li>
                  <li>Contact details (phone number, email if provided);</li>
                  <li>Geolocation (city, venue locations);</li>
                  <li>Data about sports interests, created and joined events;</li>
                  <li>Technical data such as IP address, device type, OS version, interface language, and login time.</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 3 */}
          <section className="privacy-section">
            <h2 className="privacy-section-title">
              3. {language === 'ru' ? 'Цели обработки данных' : 'Purpose of Data Processing'} /{' '}
              {language === 'ru' ? 'Purpose of Data Processing' : 'Цели обработки данных'}
            </h2>
            <div className="privacy-bilingual">
              <div className="privacy-text-block">
                <p>Персональные данные обрабатываются для следующих целей:</p>
                <ul>
                  <li>Регистрация и идентификация Пользователя;</li>
                  <li>Обеспечение функционирования Приложения;</li>
                  <li>Отправка уведомлений о событиях, обновлениях и спортивных мероприятиях;</li>
                  <li>Техническая поддержка и обратная связь;</li>
                  <li>Улучшение качества сервиса и аналитика использования.</li>
                </ul>
              </div>
              <div className="privacy-text-block">
                <p>Personal data are processed for the following purposes:</p>
                <ul>
                  <li>User registration and identification;</li>
                  <li>Providing the App's core functionality;</li>
                  <li>Sending notifications about events, updates, and activities;</li>
                  <li>Technical support and feedback;</li>
                  <li>Service improvement and analytics.</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 4 */}
          <section className="privacy-section">
            <h2 className="privacy-section-title">
              4. {language === 'ru' ? 'Правовые основания' : 'Legal Basis for Processing'} /{' '}
              {language === 'ru' ? 'Legal Basis for Processing' : 'Правовые основания'}
            </h2>
            <div className="privacy-bilingual">
              <div className="privacy-text-block">
                <p>Обработка данных осуществляется на основании:</p>
                <ul>
                  <li>согласия Пользователя на обработку персональных данных;</li>
                  <li>необходимости исполнения договора (оказания услуг через Приложение);</li>
                  <li>законных интересов Оператора в улучшении работы сервиса.</li>
                </ul>
              </div>
              <div className="privacy-text-block">
                <p>Processing is carried out based on:</p>
                <ul>
                  <li>the User's consent to data processing;</li>
                  <li>necessity for performance of a contract (App service delivery);</li>
                  <li>the Operator's legitimate interest in improving the service.</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 5 */}
          <section className="privacy-section">
            <h2 className="privacy-section-title">
              5. {language === 'ru' ? 'Передача данных третьим лицам' : 'Data Sharing with Third Parties'} /{' '}
              {language === 'ru' ? 'Data Sharing with Third Parties' : 'Передача данных третьим лицам'}
            </h2>
            <div className="privacy-bilingual">
              <div className="privacy-text-block">
                <p>Оператор может передавать данные третьим лицам исключительно в целях:</p>
                <ul>
                  <li>хостинга, технической поддержки, аналитики и отправки уведомлений;</li>
                  <li>выполнения требований законодательства РФ;</li>
                  <li>трансграничной передачи данных при условии обеспечения адекватного уровня защиты (в соответствии с GDPR).</li>
                </ul>
              </div>
              <div className="privacy-text-block">
                <p>The Operator may share data with third parties solely for:</p>
                <ul>
                  <li>hosting, technical support, analytics, and notification services;</li>
                  <li>compliance with applicable legal requirements;</li>
                  <li>cross-border data transfer only where an adequate level of protection is ensured (in line with GDPR).</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 6 */}
          <section className="privacy-section">
            <h2 className="privacy-section-title">
              6. {language === 'ru' ? 'Хранение и защита данных' : 'Data Storage and Protection'} /{' '}
              {language === 'ru' ? 'Data Storage and Protection' : 'Хранение и защита данных'}
            </h2>
            <div className="privacy-bilingual">
              <div className="privacy-text-block">
                <p>
                  Оператор принимает все необходимые организационные и технические меры для защиты персональных данных от несанкционированного доступа, изменения, утраты или раскрытия.
                </p>
                <p>
                  Данные хранятся на защищённых серверах и обрабатываются в соответствии с ФЗ №152 «О персональных данных» и международными стандартами защиты данных (включая GDPR).
                </p>
              </div>
              <div className="privacy-text-block">
                <p>
                  The Operator applies appropriate technical and organizational measures to protect data from unauthorized access, modification, loss, or disclosure.
                </p>
                <p>
                  Data are stored on secure servers and processed in accordance with Russian law (Federal Law No. 152-FZ) and international standards, including GDPR.
                </p>
              </div>
            </div>
          </section>

          {/* Section 7 */}
          <section className="privacy-section">
            <h2 className="privacy-section-title">
              7. {language === 'ru' ? 'Срок хранения' : 'Data Retention'} /{' '}
              {language === 'ru' ? 'Data Retention' : 'Срок хранения'}
            </h2>
            <div className="privacy-bilingual">
              <div className="privacy-text-block">
                <p>
                  Персональные данные хранятся до момента удаления учётной записи Пользователя или отзыва согласия на обработку данных.
                </p>
              </div>
              <div className="privacy-text-block">
                <p>
                  Personal data are stored until the User deletes their account or withdraws consent to data processing.
                </p>
              </div>
            </div>
          </section>

          {/* Section 8 */}
          <section className="privacy-section">
            <h2 className="privacy-section-title">
              8. {language === 'ru' ? 'Права пользователей' : 'User Rights'} /{' '}
              {language === 'ru' ? 'User Rights' : 'Права пользователей'}
            </h2>
            <div className="privacy-bilingual">
              <div className="privacy-text-block">
                <p>Пользователь имеет право:</p>
                <ul>
                  <li>получать информацию о своих данных;</li>
                  <li>требовать исправления или удаления данных;</li>
                  <li>отозвать согласие на обработку данных, направив обращение на e-mail Оператора.</li>
                </ul>
              </div>
              <div className="privacy-text-block">
                <p>The User has the right to:</p>
                <ul>
                  <li>request access to their personal data;</li>
                  <li>request correction or deletion of their data;</li>
                  <li>withdraw consent to data processing by contacting the Operator via email.</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 9 */}
          <section className="privacy-section">
            <h2 className="privacy-section-title">
              9. {language === 'ru' ? 'Контактная информация' : 'Contact Information'} /{' '}
              {language === 'ru' ? 'Contact Information' : 'Контактная информация'}
            </h2>
            <div className="privacy-bilingual">
              <div className="privacy-text-block">
                <p>
                  <strong>Оператор / Operator:</strong> ООО «ГАЛС» / LLC "GALS"
                </p>
                <p>
                  <strong>Адрес / Address:</strong> Россия, 420140, г. Казань, ул. Лаврентьева, 11, пом. 1045-1 / Lavrentyeva St. 11, office 1045-1, Kazan, 420140, Russia
                </p>
                <p>
                  <strong>E-mail:</strong> <a href="mailto:azatatata@gmail.com">azatatata@gmail.com</a>
                </p>
                <p>
                  <strong>Telegram:</strong> <a href="https://t.me/plschdk_bot" target="_blank" rel="noopener noreferrer">@plschdk_bot</a>
                </p>
                <p>
                  <strong>Website:</strong> <a href="https://sportsground.ru" target="_blank" rel="noopener noreferrer">sportsground.ru</a>
                </p>
              </div>
              <div className="privacy-text-block">
                <p>
                  <strong>Operator / Оператор:</strong> LLC "GALS" / ООО «ГАЛС»
                </p>
                <p>
                  <strong>Address / Адрес:</strong> Lavrentyeva St. 11, office 1045-1, Kazan, 420140, Russia / Россия, 420140, г. Казань, ул. Лаврентьева, 11, пом. 1045-1
                </p>
                <p>
                  <strong>E-mail:</strong> <a href="mailto:azatatata@gmail.com">azatatata@gmail.com</a>
                </p>
                <p>
                  <strong>Telegram:</strong> <a href="https://t.me/plschdk_bot" target="_blank" rel="noopener noreferrer">@plschdk_bot</a>
                </p>
                <p>
                  <strong>Website:</strong> <a href="https://sportsground.ru" target="_blank" rel="noopener noreferrer">sportsground.ru</a>
                </p>
              </div>
            </div>
          </section>

          {/* Section 10 */}
          <section className="privacy-section">
            <h2 className="privacy-section-title">
              10. {language === 'ru' ? 'Изменения политики' : 'Policy Updates'} /{' '}
              {language === 'ru' ? 'Policy Updates' : 'Изменения политики'}
            </h2>
            <div className="privacy-bilingual">
              <div className="privacy-text-block">
                <p>
                  Оператор может вносить изменения в настоящую Политику без предварительного уведомления Пользователей. Актуальная версия всегда доступна в Приложении и на сайте sportsground.ru.
                </p>
              </div>
              <div className="privacy-text-block">
                <p>
                  The Operator may update this Policy from time to time without prior notice. The latest version is always available within the App and at sportsground.ru.
                </p>
              </div>
            </div>
          </section>

          {/* Back to Home */}
          <div className="privacy-footer">
            <Link to="/" className="btn btn-primary">
              {t('common.backToHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

